export var Display;
(function (Display) {
    Display["MOBILE"] = "mobile";
    Display["TABLET"] = "tablet";
    Display["DESKTOP"] = "desktop";
})(Display || (Display = {}));
export const displayCloseButton = (display) => {
    if (display === Display.DESKTOP) {
        return {
            top: "1.5rem",
            right: "2.5rem",
        };
    }
    if (display === Display.TABLET) {
        return {
            top: "1.5rem",
            right: "1.5rem",
        };
    }
    return {
        top: "1rem",
        right: "1rem",
    };
};
export const getDialogPadding = (display) => {
    if (display === Display.DESKTOP) {
        return {
            padding: "4.5rem 2.5rem 1.5rem",
        };
    }
    if (display === Display.TABLET) {
        return {
            padding: "4.5rem 1.5rem 1rem",
        };
    }
    return {
        padding: "3.5rem 1rem 1rem",
    };
};
export const getFooterMargin = (display) => {
    if (display === Display.DESKTOP) {
        return {
            margin: "2.5rem 0 0",
        };
    }
    if (display === Display.TABLET) {
        return {
            margin: "1.5rem 0 0",
        };
    }
    return {
        margin: "1.5rem 0 0",
    };
};
//# sourceMappingURL=helper.js.map